import { ICoordinates } from '../../types/newbuildingsCompare';

/**
 * Переводит полигон ЖК из ответа infrastructure-caching в список координат.
 * Бэк присылает точки парами [lng, lat] (GeoJSON-порядок, проверено на проде); битые пары отбрасываются.
 */
export function mapDistrictPolygon(polygon: number[][] | null | undefined): ICoordinates[] {
  if (!polygon) {
    return [];
  }

  return polygon.filter(point => point.length >= 2).map(([lng, lat]) => ({ lat, lng }));
}
